// @ts-strict-ignore

import type { BaseTableResultItem, TableResult } from "@tanstack/react-table";

export interface EngagementPresetEmailTemplatesParams {
  /** the unique identifier for the current app group */
  appGroupId: string;
  /** the query object containing all the filters */
  query?: Partial<Record<string, string | string[]>>;
  /** the groupby column */
  groupby?: string;
  /** the number of records to return per page */
  limit?: number;
  /** the column on which to sort */
  sortby?: string;
  /** the direction in which to sort */
  sortdir?: -1 | 1;
  /** the index for the first record in the set among the entire response */
  start?: number;
}

const NINETY_DAYS_SECONDS = 90 * 24 * 60 * 60;

export function isPresetTemplateNew(createdAtTimestamp: number | undefined | null): boolean {
  if (!createdAtTimestamp) {
    return false;
  }
  const nowSeconds = Math.floor(Date.now() / 1000);
  return nowSeconds - createdAtTimestamp < NINETY_DAYS_SECONDS;
}

export interface EngagementPresetEmailTemplatesResultItem extends BaseTableResultItem {
  id: string;
  name: string;
  template: string;
  thumbnail_image_url;
  is_dnd_template: boolean;
  created_at_timestamp?: number | null;
}

export type EngagementPresetEmailTemplatesResult = TableResult<EngagementPresetEmailTemplatesResultItem>;
